import type { SourceLink } from "@/lib/source-link";
import { cn } from "@/lib/utils";
import { ExternalLinkIcon } from "lucide-react";

/**
 * A page the web profile rests on, as a link named by its host, opening in a
 * new tab; the touch target grows on mobile. `className` sets the display.
 */
export default function SourceHostLink({
  link,
  className,
}: {
  link: SourceLink;
  className?: string;
}) {
  return (
    <a
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "min-w-0 items-center gap-1.5 text-sm text-majorelle underline-offset-2 hover:underline max-sm:min-h-11",
        className,
      )}
    >
      <ExternalLinkIcon className="size-3.5 shrink-0" />
      <span className="truncate">{link.host}</span>
    </a>
  );
}
